import { render, staticRenderFns } from "./ProductsSelect.vue?vue&type=template&id=01ff9a17"
import script from "./ProductsSelect.vue?vue&type=script&lang=js"
export * from "./ProductsSelect.vue?vue&type=script&lang=js"
import style0 from "./ProductsSelect.vue?vue&type=style&index=0&id=01ff9a17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports